import { BaseController } from '../../../../common/base/controller';

export class ReceivedPaymentFormController extends BaseController {
  constructor(
    controllerService,
    inputFormService,
    receivedPaymentFormFields,
    $scope,
  ) {
    'ngInject';
    super({
      controllerService,
      inputFormService,
      receivedPaymentFormFields,
      $scope,
    });
  }

  get labelPrefix() {
    return 'app.ticket.finances.';
  }

  $onInit() {
    this.bindEvents();

    // Initialize fields when language options has been loaded
    this.setLanguageOptions().then(() => this.setupFields());
  }

  bindEvents() {
    const { $scope } = this;
    $scope.$on('receivedPayments.setupFields', (e, values) =>
      this.setupFields(values),
    );
  }

  setupFields(values) {
    // Initialize fields when language options has been loaded
    this.fields = this.inputFormService.getFields(
      angular.copy(this.receivedPaymentFormFields),
      this.languageOptions,
      this.model,
    );

    // Set prefill values into the fields
    if (values) {
      this.populateFields(values);
    }
  }

  populateFields(item) {
    this.$timeout(() => {
      this.model = item;
    });
  }
}
